var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fill-height"},[_vm._t("default"),_c('offline-notification'),_c('alert-pool',{staticStyle:{"z-index":"99999999"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }